import { IconButton } from '../../cdl/IconButton/IconButton';
import { translate } from '../../common/helpers/translate.helper';
import { IconCircleX } from '../../common/icons/cdl/CircleX';
import { Box } from '../../common/ui/Box';

interface RemoveCompareRowButtonProps {
    onClick: () => void;
}

export const RemoveCompareRowButton = ({ onClick }: RemoveCompareRowButtonProps) => (
    <Box position="absolute" top="10px" right="10px" zIndex="200">
        <IconButton type="button" Icon={IconCircleX} onClick={onClick} tooltipLabel={translate('compare.remove')} />
    </Box>
);
